import {ESystemActions, SystemActions, DisplayMode} from "../../actions/system/system.actions";

export const displayModeReducers = (
  state:DisplayMode = 'undefined',
    action: SystemActions
): DisplayMode =>{
  switch (action.type) {
    case ESystemActions.SetDisplayMode: {
      return action.payload;
    }
    default:
      return state;

  }
};

